// tipsStorage.ts
// Tips表示履歴管理ユーティリティ

const TIPS_KEY = "commission_tips_last_shown";
const TIPS_EXPIRE_DAYS = 30;

export function getTipsLastShown(): Date | null {
  const val = localStorage.getItem(TIPS_KEY);
  if (!val) return null;
  const date = new Date(val);
  return isNaN(date.getTime()) ? null : date;
}

export function setTipsLastShown(date: Date = new Date()) {
  localStorage.setItem(TIPS_KEY, date.toISOString());
}

export function shouldShowTips(): boolean {
  const lastShown = getTipsLastShown();
  if (!lastShown) return true;
  const now = new Date();
  const diffDays =
    (now.getTime() - lastShown.getTime()) / (1000 * 60 * 60 * 24);
  return diffDays >= TIPS_EXPIRE_DAYS;
}
